
const About = () => {
  const stats = [
    { number: '20+', label: 'Enterprise Clients' },
    { number: '15+', label: 'Years Experience' },
    { number: '5+', label: 'Certified Consultants' },
    { number: '30+', label: 'Solution Portfolio' }
  ];

  const values = [
    {
      icon: 'ri-lightbulb-line',
      title: 'Innovation',
      description: 'Continuously exploring cutting-edge technologies to deliver future-ready solutions.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Security',
      description: 'Ensuring full data security and compliance with international standards like ISO 27001.'
    },
    {
      icon: 'ri-team-line',
      title: 'Partnership',
      description: 'Building long-term relationships with clients through trust and exceptional service delivery.'
    },
    {
      icon: 'ri-trophy-line',
      title: 'Excellence',
      description: 'Delivering measurable business impact through quality solutions and continuous improvement.'
    }
  ];

  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4">About WOTECH</h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Leading digital transformation journey with comprehensive IT solutions and automation services for medium and large enterprises.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h4 className="text-3xl font-bold text-gray-900 mb-6">Our Mission & Vision</h4>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              WOTECH's mission is to simplify complex IT environments by integrating service management, automation, and analytics into a single operational ecosystem. Through deep partnerships with ManageEngine, AutomMate, and Zoho One, we empower enterprises to achieve measurable gains in efficiency, governance, and scalability.
            </p>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              We follow a "context-first" consulting philosophy, investing 80% of effort into understanding client context and 20% into direct technical execution. This approach ensures that every deployment aligns with strategic goals, operational structure, and digital maturity level.
            </p>
            <div className="flex items-center">
              <i className="ri-award-line text-teal-500 text-2xl mr-3"></i>
              <span className="text-gray-700 font-semibold">Authorized Partner of ManageEngine, AutomMate & Zoho One</span>
            </div>
          </div>
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/1fe02d4d4d933cc1d4e408fcb3258f96.jpg"
              alt="WOTECH Team"
              className="w-full h-96 object-cover rounded-xl shadow-lg"
            />
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-4xl font-bold text-blue-600 mb-2">{stat.number}</div>
              <div className="text-gray-600 font-medium">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {values.map((value, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${value.icon} text-2xl text-blue-600`}></i>
              </div>
              <h5 className="text-xl font-semibold text-gray-900 mb-3">{value.title}</h5>
              <p className="text-gray-600 leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white rounded-2xl p-8 shadow-lg">
          <h4 className="text-2xl font-bold text-gray-900 mb-6 text-center">Technology Domains</h4>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {[
              'IT Service Management (ITSM)',
              'IT Operations Management (ITOM)',
              'Endpoint & Asset Management',
              'Business Process Automation',
              'Active Directory & Identity Management',
              'Monitoring & Performance Analytics',
              'IT Workflow Integration',
              'Cloud and On-Premise Deployments'
            ].map((domain, index) => (
              <div key={index} className="flex items-center">
                <i className="ri-check-line text-teal-500 mr-2"></i>
                <span className="text-gray-700 text-sm">{domain}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
